// import SubscriptionActivateModel from "@/common/models/SubscriptionActivateModel";
import SubscriptionContainerModel from "@/common/models/SubscriptionContainerModel";
import SubscriptionModel from "@/common/models/SubscriptionModel";
import SubscriberModel from "@/common/models/SubscriberModel";
import axios from "axios";

export default class apiSubscription {

    static async create(title: string): Promise<SubscriptionModel> {        
        let response = await axios.post("api/Subscription/Create",{
            title: title
        });
                
        return SubscriptionModel.from(response.data.model)
    }

    static async save(model: SubscriptionModel): Promise<void> {
        let response = await axios.post("api/Subscription/Save", {
            model: model
        });                
    }

    static async get(subscriptionId: string): Promise<SubscriptionModel> {        
        let response = await axios.post("api/Subscription/Get",{
            globalId: subscriptionId
        });
                
        return SubscriptionModel.from(response.data.model)
    }    

    static async getAll(): Promise<Array<SubscriptionModel>> {                
        let models = new Array<SubscriptionModel>();

        let response = await axios.post("api/Subscription/GetAll");
        response.data.models.forEach((item: any) =>
            models.push(SubscriptionModel.from(item))
        );        
        
        return models;
    }
    
    static async getSubscribers(lastId: string, limit: number): Promise<Array<SubscriberModel>> {
        let models = new Array<SubscriberModel>();

        let response = await axios.post("api/Subscription/GetSubscribers", {
            lastId: lastId,
            limit: limit
        });
        response.data.models.forEach((item: any) =>
            models.push(SubscriberModel.from(item))
        );

        return models;
    }

    static async delete(subscriptionId: string): Promise<void> {      
        let response = await axios.post("api/Subscription/Delete",{
            subscriptionId: subscriptionId
        });    
    }

    static async activate(subscriptionId: string): Promise<void> {        
        let response = await axios.post("api/Subscription/Activate",{
            subscriptionId: subscriptionId
        });    
    }

    static async deactivate(subscriptionId: string): Promise<void> {        
        let response = await axios.post("api/Subscription/Deactivate",{
            subscriptionId: subscriptionId
        });    
    }

    static async cancel(memberId: string, reason: string | null = null): Promise<void> {
        await axios.post("api/Subscription/Cancel", {
            memberId: memberId,
            reason: reason,
        });
    }

    static async reinstate(memberId: string, reason: string | null = null): Promise<void> {
        await axios.post("api/Subscription/Reinstate", {
            memberId: memberId,
            reason: reason,
        });
    }
}
